module.exports = new __parcel__URL__("Proj Status Report.91e4cee0.svg").toString();